export default __webpack_public_path__ + "static/media/halloween-appbar-tile.678f51e3.svg";